import { updateThreshold } from "stores/slice/bogus/ainsight/wirelessCoverage/const";

const ainsightConfig = {
  // Overview
  "/orgs/:orgId/sites/:siteId/aiInsight/dashboard.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/aiInsight/dashboard",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "ainsightOverview",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/aiInsight/dashboard.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/aiInsight/dashboard",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "ainsightOverview",
  },
  // Service Experience
  "/orgs/:orgId/sites/:siteId/serviceExperience/connectSuccessRate.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/serviceExperience/connectSuccessRate",
    mockSelector: "ainsightServiceExperience.connectSuccessRate",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/connectSuccessRate.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/connectSuccessRate",
    mockSelector: "ainsightServiceExperience.connectSuccessRate",
  },
  "/orgs/:orgId/sites/:siteId/serviceExperience/connectTime.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/serviceExperience/connectTime",
    mockSelector: "ainsightServiceExperience.connectTime",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/connectTime.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/connectTime",
    mockSelector: "ainsightServiceExperience.connectTime",
  },
  "/orgs/:orgId/sites/:siteId/serviceExperience/guestAccessHappiness.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/serviceExperience/guestAccessHappiness",
    mockSelector: "ainsightServiceExperience.guestAccessHappiness",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/guestAccessHappiness.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/guestAccessHappiness",
    mockSelector: "ainsightServiceExperience.guestAccessHappiness",
  },
  // Captive Portal Connection Success Rate Details (Drawer)
  "/orgs/:orgId/sites/:siteId/serviceExperience/connectSuccessRate/devices.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/serviceExperience/connectSuccessRate/devices",
    mockSelector: "ainsightServiceExperience.connectSuccessRateDevices",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/connectSuccessRate/devices.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/connectSuccessRate/devices",
    mockSelector: "ainsightServiceExperience.connectSuccessRateDevices",
  },
  "/orgs/:orgId/sites/:siteId/serviceExperience/connectSuccessRate/ssids.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/serviceExperience/connectSuccessRate/ssids",
    mockSelector: "ainsightServiceExperience.connectSuccessRateSsids",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/connectSuccessRate/ssids.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/connectSuccessRate/ssids",
    mockSelector: "ainsightServiceExperience.connectSuccessRateSsids",
  },
  // Captive Portal Authentication Time Details (Drawer)
  "/orgs/:orgId/sites/:siteId/serviceExperience/connectTime/devices.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/serviceExperience/connectTime/devices",
    mockSelector: "ainsightServiceExperience.connectTimeDevices",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/connectTime/devices.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/connectTime/devices",
    mockSelector: "ainsightServiceExperience.connectTimeDevices",
  },
  "/orgs/:orgId/sites/:siteId/serviceExperience/connectTime/ssids.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/serviceExperience/connectTime/ssids",
    mockSelector: "ainsightServiceExperience.connectTimeSsids",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/connectTime/ssids.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/connectTime/ssids",
    mockSelector: "ainsightServiceExperience.connectTimeSsids",
  },
  // Captive Portal Access Satisfaction Details (Drawer)
  "/orgs/:orgId/sites/:siteId/serviceExperience/guestAccessHappiness/devices.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/serviceExperience/guestAccessHappiness/devices",
    mockSelector: "ainsightServiceExperience.guestAccessHappinessDevices",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/guestAccessHappiness/devices.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/guestAccessHappiness/devices",
    mockSelector: "ainsightServiceExperience.guestAccessHappinessDevices",
  },
  "/orgs/:orgId/sites/:siteId/serviceExperience/guestAccessHappiness/ssids.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/serviceExperience/guestAccessHappiness/ssids",
    mockSelector: "ainsightServiceExperience.guestAccessHappinessSsids",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/guestAccessHappiness/ssids.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/serviceExperience/guestAccessHappiness/ssids",
    mockSelector: "ainsightServiceExperience.guestAccessHappinessSsids",
  },
  // Security
  // Roam
  "/orgs/:orgId/sites/:siteId/roam/successRate.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/roam/successRate",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "ainsightRoam.successRate",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/roam/successRate.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/roam/successRate",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "ainsightRoam.successRate",
  },
  "/orgs/:orgId/sites/:siteId/roam/successRate/pairStats.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/roam/successRate/pairStats",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "ainsightRoam.pairStats",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/roam/successRate/pairStats.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/roam/successRate/pairStats",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "ainsightRoam.pairStats",
  },
  "/orgs/:orgId/sites/:siteId/roam/successRate/ssidStats.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/roam/successRate/ssidStats",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "ainsightRoam.ssidStats",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/roam/successRate/ssidStats.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/roam/successRate/ssidStats",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "ainsightRoam.ssidStats",
  },
  // Wireless Coverage
  "/orgs/:orgId/sites/:siteId/wirelessCoverage/signalQualification.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/wirelessCoverage/signalQualification",
    restful: true,
    method: "read",
    mockSelector: "ainsightWirelessCoverage.signalQualification",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/wirelessCoverage/signalQualification.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/wirelessCoverage/signalQualification",
    restful: true,
    method: "read",
    mockSelector: "ainsightWirelessCoverage.signalQualification",
  },
  "/orgs/:orgId/sites/:siteId/wirelessCoverage/signalQualification/devices.read":
  {
    protocol: "ws",
    resource:
      "/orgs/:orgId/sites/:siteId/wirelessCoverage/signalQualification/devices",
    restful: true,
    method: "read",
    mockSelector: "ainsightWirelessCoverage.devices",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/wirelessCoverage/signalQualification/devices.read":
  {
    protocol: "ws",
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/wirelessCoverage/signalQualification/devices",
    restful: true,
    method: "read",
    mockSelector: "ainsightWirelessCoverage.devices",
  },
  "/orgs/:orgId/sites/:siteId/wirelessCoverage/signalQualification/threshold.update":
  {
    protocol: "ws",
    resource:
      "/orgs/:orgId/sites/:siteId/wirelessCoverage/signalQualification/threshold",
    restful: true,
    method: "update",
    buildParams: (params) => params,
    action: updateThreshold,
    mockSelector: "ainsightWirelessCoverage.signalQualification",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/wirelessCoverage/signalQualification/threshold.update":
  {
    protocol: "ws",
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/wirelessCoverage/signalQualification/threshold",
    restful: true,
    method: "update",
    buildParams: (params) => params,
    action: updateThreshold,
    mockSelector: "ainsightWirelessCoverage.signalQualification",
  },
  // Link Integrity

  // Operations
  "/orgs/:orgId/sites/:siteId/operations/deviceReboot.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/operations/deviceReboot",
    mockSelector: "ainsightOperations.deviceReboot",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/operations/deviceReboot.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/operations/deviceReboot",
    mockSelector: "ainsightOperations.deviceReboot",
  },
  "/orgs/:orgId/sites/:siteId/operations/PoEError.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/operations/poeError",
    mockSelector: "ainsightOperations.PoEError",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/operations/PoEError.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/operations/poeError",
    mockSelector: "ainsightOperations.PoEError",
  },
  "/orgs/:orgId/sites/:siteId/operations/uplinkInstability.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/operations/uplinkInstability",
    mockSelector: "ainsightOperations.uplinkInstability",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/operations/uplinkInstability.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/operations/uplinkInstability",
    mockSelector: "ainsightOperations.uplinkInstability",
  },
  "/orgs/:orgId/sites/:siteId/operations/systemBottleneck.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/operations/systemBottleneck",
    mockSelector: "ainsightOperations.systemBottleneck",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/operations/systemBottleneck.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/operations/systemBottleneck",
    mockSelector: "ainsightOperations.systemBottleneck",
  },
  "/orgs/:orgId/sites/:siteId/operations/firmwareStatus.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/operations/firmwareStatus",
    mockSelector: "ainsightOperations.firmwareStatus",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/operations/firmwareStatus.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/operations/firmwareStatus",
    mockSelector: "ainsightOperations.firmwareStatus",
  },
  // Top Rebooters(Last 7 Days) (Drawer)
  "/orgs/:orgId/sites/:siteId/operations/deviceReboot/devices.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/operations/deviceReboot/devices",
    mockSelector: "ainsightOperations.deviceRebootDevices",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/operations/deviceReboot/devices.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/operations/deviceReboot/devices",
    mockSelector: "ainsightOperations.deviceRebootDevices",
  },
  // Active PoE Alerts (Drawer)
  "/orgs/:orgId/sites/:siteId/operations/poeError/portList.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/operations/poeError/portList",
    mockSelector: "ainsightOperations.poeErrorPortList",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/operations/poeError/portList.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/operations/poeError/portList",
    mockSelector: "ainsightOperations.poeErrorPortList",
  },
  // Top Affected Devices(Last 7 Days) (Drawer)
  "/orgs/:orgId/sites/:siteId/operations/uplinkInstability/devices.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/operations/uplinkInstability/devices",
    mockSelector: "ainsightOperations.uplinkInstabilityDevices",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/operations/uplinkInstability/devices.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/operations/uplinkInstability/devices",
    mockSelector: "ainsightOperations.uplinkInstabilityDevices",
  },
  // Config: High CPU / Memory Threshold (Drawer)
  "/orgs/:orgId/sites/:siteId/operations/systemBottleneck/threshold.update": {
    protocol: "ws",
    method: "update",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/operations/systemBottleneck/threshold",
    mockSelector: "ainsightOperations.systemBottleneck",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/operations/systemBottleneck/threshold.update":
  {
    protocol: "ws",
    method: "update",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/operations/systemBottleneck/threshold",
    mockSelector: "ainsightOperations.systemBottleneck",
  },
  // Top Resource Consumers (Drawer)
  "/orgs/:orgId/sites/:siteId/operations/systemBottleneck/devices.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/operations/systemBottleneck/devices",
    mockSelector: "ainsightOperations.systemBottleneckDevices",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/operations/systemBottleneck/devices.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/operations/systemBottleneck/devices",
    mockSelector: "ainsightOperations.systemBottleneckDevices",
  },
  // LinkIntegrity Wireless Congestion site overview
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wirelessCongestion.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wirelessCongestion",
    mockSelector: "ainsightLinkIntegrity.wirelessCongestionLevelChartData",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/wirelessCongestion.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/linkIntegrity/wirelessCongestion",
    mockSelector: "ainsightLinkIntegrity.wirelessCongestionLevelChartData",
  },

  // LinkIntegrity Wireless Congestion device list
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wirelessCongestion/devices.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wirelessCongestion/devices",
    mockSelector: "ainsightLinkIntegrity.wirelessCongestionLevelDeviceList",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/wirelessCongestion/devices.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/linkIntegrity/wirelessCongestion/devices",
    mockSelector: "ainsightLinkIntegrity.wirelessCongestionLevelDeviceList",
  },

  // LinkIntegrity Wireless Congestion threshold update
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wirelessCongestion/threshold.update":
  {
    protocol: "ws",
    method: "update",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wirelessCongestion/threshold",
    mockSelector:
      "ainsightLinkIntegrity.wirelessCongestionLevelUpdateThreshold",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/wirelessCongestion/threshold.update":
  {
    protocol: "ws",
    method: "update",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/linkIntegrity/wirelessCongestion/threshold",
    mockSelector:
      "ainsightLinkIntegrity.wirelessCongestionLevelUpdateThreshold",
  },

  // LinkIntegrity Wired Congestion site overview
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion",
    mockSelector: "ainsightLinkIntegrity.wiredCongestionLevelChartData",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion",
    mockSelector: "ainsightLinkIntegrity.wiredCongestionLevelChartData",
  },

  // LinkIntegrity Wired Congestion peak hourly
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion/peak.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion/peak",
    mockSelector: "ainsightLinkIntegrity.wiredCongestionLevelPeakHourly",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion/peak.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion/peak",
    mockSelector: "ainsightLinkIntegrity.wiredCongestionLevelPeakHourly",
  },

  // LinkIntegrity Wired Congestion device port list
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion/device.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion/device",
    mockSelector: "ainsightLinkIntegrity.wiredCongestionLevelDeviceList",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion/device.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion/device",
    mockSelector: "ainsightLinkIntegrity.wiredCongestionLevelDeviceList",
  },

  // LinkIntegrity Wired Congestion threshold update
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion/threshold.update":
  {
    protocol: "ws",
    method: "update",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion/threshold",
    mockSelector: "ainsightLinkIntegrity.wiredCongestionLevelUpdateThreshold",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion/threshold.update": {
    protocol: "ws",
    method: "update",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCongestion/threshold",
    mockSelector: "ainsightLinkIntegrity.wiredCongestionLevelUpdateThreshold",
  },

  // LinkIntegrity Wired Link Degradation site overview
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredLinkDegration.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredLinkDegration",
    mockSelector: "ainsightLinkIntegrity.wiredLinkDegradationChartData",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredLinkDegration.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredLinkDegration",
    mockSelector: "ainsightLinkIntegrity.wiredLinkDegradationChartData",
  },

  // LinkIntegrity Wired Link Degradation port list
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredLinkDegration/portList.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredLinkDegration/portList",
    mockSelector: "ainsightLinkIntegrity.wiredLinkDegradationPortList",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredLinkDegration/portList.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredLinkDegration/portList",
    mockSelector: "ainsightLinkIntegrity.wiredLinkDegradationPortList",
  },

  // LinkIntegrity Wired Cable Quality site overview
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCableQuality.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCableQuality",
    mockSelector: "ainsightLinkIntegrity.wiredCableQualityChartData",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCableQuality.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCableQuality",
    mockSelector: "ainsightLinkIntegrity.wiredCableQualityChartData",
  },

  // LinkIntegrity Wired Cable Quality port list
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCableQuality/portList.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCableQuality/portList",
    mockSelector: "ainsightLinkIntegrity.wiredCableQualityPortList",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCableQuality/portList.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/linkIntegrity/wiredCableQuality/portList",
    mockSelector: "ainsightLinkIntegrity.wiredCableQualityPortList",
  },
  // LinkIntegrity Channel Interference site overview
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/channelInterference.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/channelInterference",
    mockSelector: "ainsightLinkIntegrity.channelInterferenceChartData",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/channelInterference.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/linkIntegrity/channelInterference",
    mockSelector: "ainsightLinkIntegrity.channelInterferenceChartData",
  },
  // LinkIntegrity Channel Interference ap list
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/channelInterference/apList.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/channelInterference/apList",
    mockSelector: "ainsightLinkIntegrity.channelInterferenceApList",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/channelInterference/apList.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/linkIntegrity/channelInterference/apList",
    mockSelector: "ainsightLinkIntegrity.channelInterferenceApList",
  },

  // LinkIntegrity Channel Interference threshold update
  "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/channelInterference/threshold.update":
  {
    protocol: "ws",
    method: "update",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/linkIntegrity/channelInterference/threshold",
    mockSelector: "ainsightLinkIntegrity.channelInterferenceUpdateThreshold",
  },
  "/orgs/:orgId/sites/:siteId/linkIntegrity/channelInterference/threshold.update":
  {
    protocol: "ws",
    method: "update",
    restful: true,
    resource:
      "/orgs/:orgId/sites/:siteId/linkIntegrity/channelInterference/threshold",
    mockSelector: "ainsightLinkIntegrity.channelInterferenceUpdateThreshold",
  },
  // Security Rogue Ap Detection site overview
  "/ents/:entId/orgs/:orgId/sites/:siteId/security/rogueApDetection.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/security/rogueApDetection",
    mockSelector: "ainsightSecurity.securityRogueApDetectionChartData",
  },
  "/orgs/:orgId/sites/:siteId/security/rogueApDetection.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/security/rogueApDetection",
    mockSelector: "ainsightSecurity.securityRogueApDetectionChartData",
  },
  // Security Rogue Ap Detection ap List
  "/ents/:entId/orgs/:orgId/sites/:siteId/security/rogueApDetection/apList.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/security/rogueApDetection/apList",
    mockSelector: "ainsightSecurity.securityRogueApDetectionApList",
  },
  "/orgs/:orgId/sites/:siteId/security/rogueApDetection/apList.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/security/rogueApDetection/apList",
    mockSelector: "ainsightSecurity.securityRogueApDetectionApList",
  },
  // Security Rogue Ap Detection update status
  "/ents/:entId/orgs/:orgId/sites/:siteId/security/rogueApDetection/states.update":
  {
    protocol: "ws",
    method: "update",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/security/rogueApDetection/states",
    mockSelector: "ainsightSecurity.securityRogueApDetectionUpdateStatus",
  },
  "/orgs/:orgId/sites/:siteId/security/rogueApDetection/states.update": {
    protocol: "ws",
    method: "update",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/security/rogueApDetection/states",
    mockSelector: "ainsightSecurity.securityRogueApDetectionUpdateStatus",
  },
  // Security Abnormal Location site overview
  "/ents/:entId/orgs/:orgId/sites/:siteId/security/abnormalLocation.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/security/abnormalLocation",
    mockSelector: "ainsightSecurity.securityAbnormalLocationChartData",
  },
  "/orgs/:orgId/sites/:siteId/security/abnormalLocation.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/security/abnormalLocation",
    mockSelector: "ainsightSecurity.securityAbnormalLocationChartData",
  },
  // Security Abnormal Location client List
  "/ents/:entId/orgs/:orgId/sites/:siteId/security/abnormalLocation/clientList.read":
  {
    protocol: "ws",
    method: "read",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/security/abnormalLocation/clientList",
    mockSelector: "ainsightSecurity.securityAbnormalLocationClientList",
  },
  "/orgs/:orgId/sites/:siteId/security/abnormalLocation/clientList.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/security/abnormalLocation/clientList",
    mockSelector: "ainsightSecurity.securityAbnormalLocationClientList",
  },
  // Security Abnormal Location update action
  "/ents/:entId/orgs/:orgId/sites/:siteId/security/abnormalLocation/action.update":
  {
    protocol: "ws",
    method: "update",
    restful: true,
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/security/abnormalLocation/action",
    mockSelector: "ainsightSecurity.securityAbnormalLocationUpdateAction",
  },
  "/orgs/:orgId/sites/:siteId/security/abnormalLocation/action.update": {
    protocol: "ws",
    method: "update",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/security/abnormalLocation/action",
    mockSelector: "ainsightSecurity.securityAbnormalLocationUpdateAction",
  },
};

export default ainsightConfig;
